var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button-base',{staticClass:"button-direction",class:_vm.classObject,on:{"click":_vm.clickEvent}})
}
var staticRenderFns = []

export { render, staticRenderFns }